<script>
import SvgIconInline from '@/components/SvgIconInline';
import { mapState, mapActions } from 'vuex';
import { checkCloseModalMenu } from '@/scripts/methods';

export default {
  name: 'MediaLink',
  components: {
    SvgIconInline,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState([]),
    href() {
      const { item } = this;
      const { url } = item;
      const result = url;

      return result;
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
    checkCloseModalMenu,
  },
};
</script>

<template>
  <a
    :href="href"
    target="_blank"
    @click="checkCloseModalMenu"
    class="media-link"
  >
    <SvgIconInline :name="item.name"></SvgIconInline>
  </a>
</template>

<style lang="scss">
@import '@/styles/variables.scss';
.media-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 50%;
  border: 0.8px solid #ffc107;
  transition: all 0.2s;

  .icon {
    fill: #ffc107;
    transition: all 0.2s;
  }

  &:hover {
    background: #ffc107;

    .icon {
      fill: #161c1d;
    }
  }

  & > div {
    display: flex;
  }

  &--lg {
    width: 36px;
    height: 36px;

    .icon {
      &.telegram {
        width: 16px;
        height: 14px;
      }
      &.facebook {
        width: 9px;
        height: 16px;
      }
      &.youtube {
        width: 16px;
        height: 12px;
      }
      &.twitter,
      &.medium {
        width: 16px;
        height: 13px;
      }
    }
  }
}

@media (max-width: $mobile) {
  .media-link {
    &:hover {
      background: transparent;

      .icon {
        fill: #ffc107;
      }
    }
  }
}
</style>
